import type {OptionProps} from "react-select";
import {Option as DefaultOption} from "@/components/ui/Select";
import Avatar from "@/components/ui/Avatar/Avatar";
import React from "react";

export default function CountryPhoneCustomSelectOption(
  props: OptionProps<CountryOption> & { variant: "country" | "phone" }
) {
  return (
    <DefaultOption<CountryOption>
      {...props}
      customLabel={(data, label) => (
        <span className="flex items-center gap-2">
          <Avatar
            shape="circle"
            size={20}
            src={`/img/countries/${data.value}.png`}
          />
          {props.variant === "country" && <span>{label}</span>}
          {props.variant === "phone" && <span>{data.dialCode}</span>}
        </span>
      )}
    />
  );
};

export type CountryOption = {
  label: string;
  dialCode: string;
  value: string;
};
